'use client';

import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import SpiderChart from './SpiderChart';

interface ChartGeneratorProps {
  answers: number[];
  onChartGenerated: (base64Image: string) => void;
}

export default function ChartGenerator({ answers, onChartGenerated }: ChartGeneratorProps) {
  useEffect(() => {
    const chartWidth = 700;
    const chartHeight = 700;

    const container = document.createElement('div');
    Object.assign(container.style, {
      position: 'fixed',
      left: '-9999px',
      top: '0',
      width: `${chartWidth}px`,
      height: `${chartHeight}px`,
    });
    document.body.appendChild(container);

    const generateImage = async () => {
      try {
        const reactRoot = createRoot(container);
        reactRoot.render(
          <SpiderChart answers={answers} width={chartWidth} height={chartHeight} />
        );

        await new Promise((resolve) => setTimeout(resolve, 500));

        const canvas = await html2canvas(container, {
          scale: 2,
          backgroundColor: null,
          logging: false,
        });

        const base64Image = canvas.toDataURL('image/png');
        onChartGenerated(base64Image);

        reactRoot.unmount();
        document.body.removeChild(container);
      } catch (error) {
        console.error('Error generating chart image:', error);
        if (document.body.contains(container)) {
          document.body.removeChild(container);
        }
      }
    };

    generateImage();
  }, [answers, onChartGenerated]);

  return null;
} 